import { useLocalSearchParams } from "expo-router";

import PageLayout from "$src/core/components/templates/PageLayout";
import useMenu from "$src/core/hooks/use-menu";
import DynamicPage from "$src/core/pages/DynamicPage/DynamicPage";
import EPGPage from "$src/core/pages/EPGPage";
import LoadingPage from "$src/core/pages/LoadingPage/LoadingPage";
import NotFoundPage from "$src/core/pages/NotFoundPage/NotFoundPage";
import ProfilePage from "$src/core/pages/ProfilePage";
import SearchPage from "$src/core/pages/SearchPage";
import StorefrontPage from "$src/core/pages/StorefrontPage";
import WatchlistPage from "$src/core/pages/WatchlistPage/WatchlistPage";

type Params = {
  slug?: string;
};

const DynamicRoute = ({ slot }: { slot: number }) => {
  const { slug } = useLocalSearchParams<Params>();

  const menu = useMenu();

  if (!menu) {
    return (
      <PageLayout>
        <LoadingPage />
      </PageLayout>
    );
  }

  const item = slug
    ? menu.routable.find((tab) => tab.slug === slug)
    : menu.routable.find((tab) => tab.slot === slot);

  if (!item) {
    return (
      <PageLayout>
        <NotFoundPage />
      </PageLayout>
    );
  }

  const content = (() => {
    switch (item.type) {
      case "storefront":
        return <StorefrontPage />;
      case "watchlist":
        return <WatchlistPage />;
      case "search":
        return <SearchPage />;
      case "profile":
        return <ProfilePage />;
      case "epg":
        return <EPGPage />;
      default:
        return <DynamicPage slug={item.slug} />;
    }
  })();

  return <PageLayout>{content}</PageLayout>;
};

export default DynamicRoute;
